export interface INotificationState {
    saveNotification: customNotification | undefined;
}


export const DefaultState = (): INotificationState => ({
    saveNotification: undefined,
})
